"use strict";
/**
 * @module Services.GatewayControl
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatewayClientDetailSerialiser = exports.GatewayClientDetailSerialiserClass = void 0;
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var gateway_client_connected_client_details_serialiser_1 = require("./../../services/gateway-control/gateway-client-connected-client-details-serialiser");
var gateway_client_key_serialiser_1 = require("./../../services/gateway-control/gateway-client-key-serialiser");
/**
 * Serialiser for {@link GatewayClientDetail}
 */
var GatewayClientDetailSerialiserClass = /** @class */ (function (_super) {
    __extends(GatewayClientDetailSerialiserClass, _super);
    function GatewayClientDetailSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link GatewayClientDetail} from the stream
     *
     * @param bis the input stream
     * @return    the {@link GatewayClientDetail} that was read
     */
    GatewayClientDetailSerialiserClass.prototype.read = function (bis) {
        var key = gateway_client_key_serialiser_1.GatewayClientKeySerialiser.read(bis);
        var connectedClientDetails = Codec.readByte(bis) ? gateway_client_connected_client_details_serialiser_1.GatewayClientConnectedClientDetailsSerialiser.read(bis) : undefined;
        return {
            key: key,
            connectedClientDetails: connectedClientDetails
        };
    };
    return GatewayClientDetailSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.GatewayClientDetailSerialiserClass = GatewayClientDetailSerialiserClass;
/**
 * The {@link GatewayClientDetailSerialiser} singleton
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
exports.GatewayClientDetailSerialiser = new GatewayClientDetailSerialiserClass();
